import React from 'react'
import { profiles, paths } from '../misc/Static'
import Champ from '../images/Champ'
import styles from './Filter.module.css'

export const Filter = ({mids, filterChamp, filterQueue,clearFilter,cid,queue}) => {
  let cids={}
  let queues={}

  mids.forEach((match)=>{
    if (match.length ===1 || typeof paths[match[1]] === 'undefined') return
    if (!cids[match[1]]) cids[match[1]] = 0
    cids[match[1]]++
    if (!queues[match[2]]) queues[match[2]] = 0
    queues[match[2]]++
  })

  let champions = Object.keys(cids).map((cid)=>[parseInt(cid),cids[cid]])
  champions.sort((a, b) => { a = a[1]; b = b[1]; return a > b ? -1 : (a < b ? 1 : 0); })
  let queueList = Object.keys(queues).filter((q)=>profiles.queues[q]).map((q)=>[parseInt(q),queues[q]])
  queueList.sort((a, b) => { a = a[1]; b = b[1]; return a > b ? -1 : (a < b ? 1 : 0); })

  return (
    <div className={styles.filter}>
      <div>FILTER:</div>
      {queueList.map((q,i)=><div key={i} className={styles['queuefilter' + (!queue || queue=== q[0] ? 'active' : '')]} onClick={e=>filterQueue(e)} data-id={q[0]}>{profiles.queues[q[0]]} <span>x {q[1]}</span></div>)}
      {champions.map((champ,i)=><div key={i} className={styles['champfilter' + (!cid || cid=== champ[0] ? 'active' : '')]} onClick={e=>filterChamp(e)} data-id={champ[0]}><Champ type="champ28" id={champ[0]} /><div>{champ[1]}</div></div>)}
      {(cid !==false || queue !==false) && <div className={styles.clearfilter} onClick={clearFilter}>x</div> }
    </div>
  )
}

export default Filter
